// Sur iOS/Android, WKWebView sert les fichiers du bundle via le schema
// capacitor://, resolu par un gestionnaire natif et non par un vrai serveur
// HTTP : la reponse arrive donc avec un status 0, corps valide mais
// response.ok a false. Tone.js teste response.ok avant de decoder
// (ToneAudioBuffer.load), si bien que TOUS ses samplers echouent en natif avec
// "could not load url", en silence, alors que le fichier est present et
// decodable. multiNotePlayer contourne deja le probleme de son cote en passant
// par XMLHttpRequest et en acceptant status 0.
//
// On normalise ici la reponse pour les seuls fichiers audio locaux, ce qui
// repare d'un coup le piano de tap, les instruments d'accords et le bouton Ear.

import { Capacitor } from '@capacitor/core';

const LOCAL_AUDIO = /\.(m4a|mp3|wav|ogg|flac)(\?|#|$)/i;

let patched = false;

export const patchNativeAudioFetch = () => {
  if (patched || !Capacitor.isNativePlatform()) return;
  if (typeof window === 'undefined' || typeof window.fetch !== 'function') return;
  patched = true;

  const originalFetch = window.fetch.bind(window);

  window.fetch = async (input, init) => {
    const response = await originalFetch(input, init);
    if (response.status !== 0) return response;

    const url = typeof input === 'string' ? input : (input && input.url) || '';
    if (!LOCAL_AUDIO.test(url)) return response;

    const body = await response.arrayBuffer();
    return new Response(body, {
      status: 200,
      headers: { 'Content-Type': 'audio/mp4' }
    });
  };
};

// Applique a l'import, et pas sur appel du consommateur : le singleton
// audioEngine prechauffe sa banque de samples depuis son constructeur, donc
// pendant la phase d'import. Un patch pose apres arriverait trop tard, la
// banque resterait mémorisee en echec pour toute la session.
patchNativeAudioFetch();

export default patchNativeAudioFetch;
